export const canopyPhone = '1-855-616-7305'
export const licenseMap = {
  'practiceManagement': 'Practice Management',
  'practiceManagementPro': 'Practice Management Professional',
  'firmManagement': 'Firm Management - Workflow & Advanced Reporting',
  'taxResolution': 'Tax Resolution',
  'irsNotices': 'Notices',
  'transcripts': 'Transcripts',
  'workflow': 'Workflow',
  'documentManagement': 'Document Management',
  'clientManagement': 'Client Management',
  'timeAndBilling': 'Time and Billing'
}
